import { ReactNode } from "react";
import Search from "../components/icons/Search";
import { TransferInstruction } from "../class/transferInstruction";
import { Arrow, CheckMark, ExclaimationMark, Money } from "../components/icons";
import { CHEVRON_ORIENTATION_RIGHT } from "../components/icons/constants";

const convertTransferStatus = (
  transferInstruction: TransferInstruction,
): {
  progress: number;
  title: string;
  icon: ReactNode;
  disabled?: boolean;
} => {
  if (transferInstruction.transferExternalStatus === "Pending Destination Account") {
    return {
      progress: 0,
      title: transferInstruction.transferExternalStatus,
      icon: <ExclaimationMark name="exclaimation" color="#305953" height={17} />,
      disabled: true,
    };
  }
  if (
    transferInstruction.transferExternalStatus === "Pending Roth Destination Account" ||
    transferInstruction.transferExternalStatus === "Pending TRAD Destination Account" ||
    transferInstruction.transferExternalStatus === "Pending Traditional Destination Account"
  ) {
    return {
      progress: 50,
      title: transferInstruction.transferExternalStatus,
      icon: <ExclaimationMark name="exclaimation" color="#305953" height={17} />,
      disabled: true,
    };
  }
  if (transferInstruction.transferExternalStatus === "Additional Information Needed") {
    return {
      progress: 50,
      title: transferInstruction.transferExternalStatus,
      icon: <ExclaimationMark name="exclaimation" color="#305953" height={17} />,
      disabled: true,
    };
  }
  if (transferInstruction.transferExternalStatus === "Processing") {
    return {
      progress: 25,
      title: "Processing transfer details",
      icon: <Search width={18} height={17} name="search" color="#305953" />,
    };
  }
  if (transferInstruction.transferExternalStatus === "Transfer Initiated At Source") {
    return {
      progress: 50,
      title: "Transfer initiated",
      icon: <Arrow width={18} height={15} orienation={CHEVRON_ORIENTATION_RIGHT} name="arrow" color="#305953" />,
    };
  }
  if (transferInstruction.transferExternalStatus === "Check Sent To Destination") {
    return {
      progress: 75,
      title: "Funds on the way",
      icon: <Money width={22} height={22} name="money" color="#305953" />,
    };
  }

  if (transferInstruction.transferExternalStatus === "Transfer Complete") {
    return {
      progress: 100,
      title: "Transfer complete",
      icon: <CheckMark name="checkmark" width={18} height={12} color="#305953" />,
    };
  }
  if (transferInstruction.transferExternalStatus === "Transfer Canceled") {
    return {
      progress: 0,
      title: "Transfer cancelled",
      icon: <ExclaimationMark name="exclaimation" color="#305953" height={17} />,
      disabled: true,
    };
  }
  return {
    progress: 25,
    title: transferInstruction.transferExternalStatus,
    icon: <Search width={22} height={22} />,
  };
};
export default convertTransferStatus;
